var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider', {
    staticClass: "border-2 grey darken-4"
  }), _vm._l(_vm.notifications, function (notification) {
    return [_c('v-row', {
      key: notification._id,
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/center/notice/".concat(notification._id)
      }
    }, [_c('v-row', {
      staticClass: "flex-md-nowrap",
      attrs: {
        "no-gutters": "",
        "align": "center",
        "justify": "space-between"
      }
    }, [_c('v-col', {
      staticClass: "flex-grow-1 flex-shrink-0",
      attrs: {
        "cols": "12",
        "md": "9"
      }
    }, [_c('div', {
      staticClass: "px-12px pt-12px pb-6px px-md-16px py-md-30px"
    }, [_c('div', {
      staticClass: "txt txt--lg txt--dark text-truncate"
    }, [_vm._v(_vm._s(notification === null || notification === void 0 ? void 0 : notification.subject))])])]), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('div', {
      staticClass: "px-12px pb-10px py-md-30px"
    }, [_c('div', {
      staticClass: "txt txt--lg txt--light"
    }, [_vm._v(_vm._s(_vm.$dayjs(notification === null || notification === void 0 ? void 0 : notification.createdAt).format("YYYY-MM-DD")))])])])], 1)], 1)], 1)], 1), _c('v-divider', {
      key: notification._id,
      staticClass: "border-light"
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }